// =============================================================================
// FILE PATH : src/modules/pms/task_template/constants/taskTemplateConstants.js
// MODULE    : PMS → Task Template
// PURPOSE   : Constants for Task Template module
// =============================================================================


// -----------------------------------------------------------------------------
// TASK CATEGORY ENUM
// -----------------------------------------------------------------------------
export const TASK_CATEGORIES = [
  "CIVIL",
  "MECHANICAL",
  "ELECTRICAL"
];


// -----------------------------------------------------------------------------
// TEMPLATE TYPE ENUM
// -----------------------------------------------------------------------------
export const TEMPLATE_TYPES = [
  { label: "Project", value: "PROJECT" },
  { label: "Equipment", value: "EQUIPMENT" }
];


// -----------------------------------------------------------------------------
// STATUS OPTIONS
// -----------------------------------------------------------------------------
export const TEMPLATE_STATUS = [
  { label: "Active", value: true },
  { label: "Inactive", value: false }
];


// -----------------------------------------------------------------------------
// DEFAULT TASK ITEM
// -----------------------------------------------------------------------------
export const DEFAULT_TASK_ITEM = {
  task_name: "",
  description: "",
  task_category: "CIVIL",
  default_duration: 1,
  sequence_no: 1
};